import { atom } from 'jotai';
import { atomWithRefresh } from 'jotai/utils';
import { parseURL } from '../parseURL';
import { ExerciseDto, LogbookPersonalEntryDto } from '../../modules/interfaces';
import { stringifyProgram } from '../../modules/interfaces/Program';
import { personalEntriesAtom, personalEntryEditAtom } from './personalEntries';

export const locationAtom = atomWithRefresh(() => location.href);
locationAtom.onMount = (set) => {
    function handler(event: PopStateEvent) {
        set();
    }
    window.addEventListener('popstate', handler);
    return () => {
        window.removeEventListener('popstate', handler);
    };
};
export const urlParamsAtom = atom((get) => parseURL(get(locationAtom)));

export const topLevelPageAtom = atom<
    | 'personal-notes'
    | 'edit-personal-note'
    | 'exercise'
    | 'modules'
    | 'thermometer'
>((get) => {
    const urlParams = get(urlParamsAtom);
    if (urlParams.showPersonalNoteEditor) {
        return 'edit-personal-note';
    }
    if (urlParams.showPersonalNotes) {
        return 'personal-notes';
    }
    if (urlParams.showThermometerOverview) {
        return 'thermometer';
    }
    if (get(requestedExerciseCodeAtom)) {
        return 'exercise';
    }
    return 'modules';
});
export const requestedExerciseCodeAtom = atom(
    (get) => get(urlParamsAtom).exerciseCode,
);
export const personalNoteIdAtom = atom(
    (get) => get(urlParamsAtom).personalNoteId,
);

export const showPersonalNotesAtom = atom(null, (get, set) => {
    history.pushState({}, null, `/logbook/personal`);
    set(locationAtom);
});
export const showExerciseAtom = atom(
    null,
    (get, set, exercise: ExerciseDto) => {
        const program = stringifyProgram(exercise.Program);
        history.pushState(
            { module: exercise.ModuleId.Value },
            null,
            `/logbook/${program}/${exercise.Code}`,
        );
        set(locationAtom);
    },
);
export const editPersonalNotesAtom = atom(
    null,
    async (get, set, entryID: number | null) => {
        let entry: LogbookPersonalEntryDto = null;
        if (entryID) {
            const entries = await get(personalEntriesAtom);
            entry = entries.find((x) => x.Id === entryID);
        }

        set(personalEntryEditAtom, {
            Id: entry?.Id,
            Title: entry?.Title ?? '',
            Text: entry?.Text ?? '',
        });

        history.pushState({}, null, `/logbook/editor/${entryID ?? ''}`);
        set(locationAtom);
    },
);
export const showThermometerOverviewAtom = atom(null, (get, set) => {
    history.pushState({}, null, `/logbook/thermometeroverview`);
    set(locationAtom);
});
